module.exports = __webpack_public_path__ + "img/Savings.0609d4f.png";